import { Box } from '@dtx-company/design-system/src/components/Box/Box'
import { Button } from '@dtx-company/design-system/src/components/Button/Button'
import { Close as CloseIcon } from '@mui/icons-material'
import { Drawer } from '@dtx-company/design-system/src/components/Drawer/Drawer'
import { FC, SyntheticEvent } from 'react'
import { PrintStoreTemplatesFilter } from './PrintStoreTemplatesFilter'
import { TemplateFilterSection } from './types'
import { Typography } from '@dtx-company/design-system/src/components/Typography/Typography'
import { usePrintStoreTemplatesFilters } from './hooks'
import { visuallyHidden } from '@mui/utils'

export const MobileFiltersModal: FC<{
  open: boolean
  onClose: () => void
  clearTemplates: () => void
}> = ({ open, onClose, clearTemplates }) => {
  const { onChangeHandler: resetVerticals } = usePrintStoreTemplatesFilters({
    sectionName: TemplateFilterSection.Vertical,
    clearTemplates
  })
  const { onChangeHandler: resetUseCases } = usePrintStoreTemplatesFilters({
    sectionName: TemplateFilterSection.UseCase,
    clearTemplates
  })

  const clearAllFilters = (e: SyntheticEvent<Element, Event>): void => {
    resetVerticals(e, [], 'clear')
    resetUseCases(e, [], 'clear')
  }

  return (
    <Drawer anchor="bottom" open={open} onClose={onClose}>
      <Box
        sx={theme => ({
          padding: theme.spacing(4),
          paddingBottom: '70vh',
          display: 'flex',
          flexDirection: 'column',
          rowGap: theme.spacing(8),
          position: 'relative'
        })}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center',
            '& > button': {
              minWidth: 'unset',
              padding: 'unset'
            }
          }}
        >
          <Typography variant="subtitleMedium">Filters</Typography>
          <Button variant="text" onClick={onClose}>
            <span style={visuallyHidden}>Close</span>
            <CloseIcon />
          </Button>
        </Box>

        <Box
          sx={theme => ({
            display: 'flex',
            flexDirection: 'column',
            rowGap: theme.spacing(6)
          })}
        >
          <PrintStoreTemplatesFilter
            clearTemplates={clearTemplates}
            sectionName={TemplateFilterSection.Vertical}
          />
          <PrintStoreTemplatesFilter
            clearTemplates={clearTemplates}
            sectionName={TemplateFilterSection.UseCase}
          />
        </Box>

        <Box
          sx={theme => ({
            position: 'absolute',
            bottom: 0,
            left: 0,
            right: 0,
            padding: theme.spacing(4),
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            gap: theme.spacing(4)
          })}
        >
          <Button fullWidth variant="outlined" onClick={clearAllFilters}>
            Clear all
          </Button>
          <Button fullWidth onClick={onClose}>
            Done
          </Button>
        </Box>
      </Box>
    </Drawer>
  )
}
